import {NgModule} from '@angular/core';
import {TopNavModule} from './top/top-nav.module';
import {LeftNavModule} from './left/left-nav.module';
import {NavigationServiceModule} from './service/navigation.module';

@NgModule({
    exports: [TopNavModule, LeftNavModule, NavigationServiceModule]
})
export class NavModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/navigation/nav.module.ts